<mat-card>
  <mat-card-header>
    <div class="flex flex-col w-full">
      <div class="row" *ngIf="complaintId == null || complaintId == 0">
        <span style="font-size: small; color: grey;padding-left: 20px;">
          You cannot edit correspondence in this view. Click on links to complaints to edit correspondence for that
          complaint.
        </span>
      </div>

      <div class="row" *ngIf="!complaintHasIrl() || !complaintHasComplaintCorrespondence()">
        <div class="alert alert-danger">

          <h4 style="color: grey;">Please correct the following issues: </h4>
          <ul>
            <li *ngIf="!complaintHasIrl()">No Business IRL Generated</li>
            <li *ngIf="!complaintHasComplaintCorrespondence()">No Complainant Letter Generated</li>
            <li *ngIf="!complaintHasComplaintCorrespondence()">If complaint was submitted in another language, please
              use alternative language template supplied by OHA WEMS team</li>
          </ul>
        </div>
      </div>

      <div class="flex flex-row rounded-lg w-full" style="background-color:#5775a8;align-items: center;">
        <div class="flex flex-row rounded-lg w-full">
          <span style="font-size: large; color: white;padding: 17px;">
            Correspondence History
          </span>
        </div>
        <div class="flex flex-row" *ngIf="!correspondenceHistoryDirty">
          <div *ngIf="parentPanel == 0" style="padding-right: 20px;">
            <button mat-raised-button (click)="newCorrespondence()" style="background: #7ABDF3;">
              Generate New Correspondence
            </button>
          </div>
        </div>
      </div>
      
    </div>
  </mat-card-header>

  <mat-card-content>
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort fxFlex="100" #TableSort="matSort"
      class="mat-elevation-z8">

      <ng-container matColumnDef="preview">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Preview</th>
        <td mat-cell *matCellDef="let correspondence" style="align-items: center;">
          <a class="glyphicon glyphicon-eye-open text-muted"
            *ngIf="!correspondence.correspondenceHistoryDirty && !correspondence.businessOnly"
            (click)="previewCorrespondence(correspondence)"><mat-icon>preview</mat-icon></a>
          <a class="glyphicon glyphicon-eye-open text-muted"
            *ngIf="!correspondence.correspondenceHistoryDirty && correspondence.businessOnly"
            (click)="previewCorrespondence(correspondence)"><mat-icon>preview</mat-icon></a>
        </td>
      </ng-container>
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
        <td mat-cell *matCellDef="let correspondence">
          <span>{{correspondence.title}}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td mat-cell *matCellDef="let correspondence">
          <span>{{getType(correspondence.typeId)}}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="generatedDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Generated</th>
        <td mat-cell *matCellDef="let correspondence">
          <span>{{correspondence.generatedDate}}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="sentDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sent</th>
        <td mat-cell *matCellDef="let correspondence">
          <span *ngIf="correspondence.sentDate != null && correspondence.sentDate.length == 0">
            <mat-icon style="color:red;">warning</mat-icon>
            <span class="glyphicon glyphicon-warning-sign text-danger" title="Sent Date Missing or Invalid Address"
              *ngIf="correspondence.discardedCorrespondence == false && correspondence.invalidAddress != true">
            </span>
          </span>
          <span>{{correspondence.sentDate}}</span>

        </td>
      </ng-container>
      <ng-container matColumnDef="discardedCorrespondence">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Discarded Correspondence</th>
        <td mat-cell *matCellDef="let correspondence">
          <span>
            <span *ngIf="correspondence.discardedCorrespondence" style="color: red">Yes</span>
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="invalidAddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Invalid Address</th>
        <td mat-cell *matCellDef="let correspondence">
          <span>
            <span *ngIf="correspondence.invalidAddress == true" class="text-success" style="color: green">Yes</span>
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="complaintId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint Id</th>
        <td mat-cell *matCellDef="let correspondence">
          <span *ngIf="complaintId != null && complaintId > 0">{{correspondence.complaintId}}</span>
          <a *ngIf="complaintId == null || complaintId == 0" (click)="loadComplaint(correspondence.complaintId)"
            target="_blank">{{correspondence.complaintId}}</a>
        </td>
      </ng-container>
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Edit</th>
        <td mat-cell *matCellDef="let correspondence">
          <button *ngIf="!businessOnly" (click)="editCorrespondence(correspondence)" matTooltip="Edit Correspondence"
            style="margin-right: 20px;">
            <!-- Download -->
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="hasAttachment">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Attachments</th>
        <td mat-cell *matCellDef="let correspondence">
          <div
            *ngIf="correspondence.hasAttachment && !correspondenceHistoryDirty && complaintId!=null && complaintId > 0"
            class="flex flex-row">
            <button (click)="downloadAttachment(correspondence)" matTooltip="Download Attachment"
              style="margin-right: 20px;">
              <!-- Download -->
              <mat-icon>file_download</mat-icon>
            </button>
            <button (click)="removeAttachment(correspondence)" matTooltip="Delete Attachment">
              <mat-icon style="color:red;">delete</mat-icon>
            </button>
          </div>
          <div *ngIf="showAttachments(correspondence)">
            <button mat-raised-button (click)="attachDocumentSetup(correspondence)" matTooltip="Attach File">
              <mat-icon>save</mat-icon> Attach File
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>
    </table>

  </mat-card-content>

</mat-card>